export default __webpack_public_path__ + "static/media/demo.edcaf373.jpeg";